import React from 'react'
import { urlFor } from '@/utils/sanity'
import { getImageDimensions } from '@sanity/asset-utils'
import clsx from 'clsx'

const Image = ({ image, alt }) => {
	const { width, height } = getImageDimensions(image)

	return (
		<img
			className="mx-auto max-h-[80vh] w-auto"
			src={urlFor(image).auto('format').url()}
			alt={alt || ''}
			width={width} height={height}
			loading="lazy"
		/>
	)
}

const RtImage = ({ value: { image, url, source }, notFullWidth }) => {
	if (!image?.image) return null

	return (
		<figure className={clsx('rt-image text-center', !notFullWidth && '<md:full-width !my-8')}>
			{!!url
				? <a href={url} className="hover:opacity-80" target="_blank">
					<Image {...image} />
				</a>
				: <Image {...image} />
			}

			{!!image?.caption && (
				<figpcation className="block mt-4 text-sm italic">
					{image.caption}
				</figpcation>
			)}

			{!!source && (
				<cite className="block mt-4 text-sm">
					Source: <a href={source} target="_blank" rel="noopener">{source}</a>
				</cite>
			)}
		</figure>
	)
}

export default RtImage
